import React from "react";

export default function Card(props) {
    const { order, index, handleDelete } = props;

    const renderStatus = (status) =>
        status === "PAGO"
            ? <span className="badge badge-success">Pago</span>
            : <span className="badge badge-warning">Pendente</span>

    return (
        <div className="col-12 card mb-1 py-2 px-3" key={index} id={index}>
            <div className="row">
                <div className="col-1">
                    <h6 className="mb-0 text-truncate">{order.ticketId}</h6>
                    {renderStatus(order.status)}
                </div>
                <div className="col-4">
                    <h6 className="mb-1 text-truncate">{order.nome}</h6>
                    <h6 className="mb-0 text-truncate">{order.email}</h6>
                </div>
                <div className="col-2 align-items-center d-flex">
                    <h6 className="mb-0 text-truncate">{order.telefone}</h6>
                </div>
                <div className="col-3">
                    <h6 className="mb-1 text-truncate">{order.cargo}</h6>
                    <h6 className="mb-0 text-truncate">{order.empresa}</h6>
                </div>
                <div className="col-2 align-items-center d-flex">
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(order.ticketId)}>Delete</button>
                </div>
            </div>
        </div>
    );
}
